import Cookies from 'js-cookie';

const saveToCookie = (key: string, value: string, expires: number = 7) => {
  Cookies.set(key, value, { expires: expires, secure: process.env.SECURE_COOKIE === 'true' });
};

export default saveToCookie;
